import { Text } from '@app/components'
import { TextProps } from '@app/types'
import styled from 'styled-components'

export const StyledText = styled((props: TextProps) => <Text {...props} />)`
  color: ${(props) => props.theme.color.darkGrey};
`
